import { clsxm } from '@app/styles/clsxm';
import { usePlanLimitGetDialogContent } from './usePlanLimitGetDialogContent';
import { EPlanLimitType } from './PlanLimitDialog';

export const PlanLimitProductPreview: React.FC<{
  triggerPopup: EPlanLimitType | null;
  hideFreeBadge?: boolean;
}> = ({ triggerPopup, hideFreeBadge }) => {
  const { decorativeContent } = usePlanLimitGetDialogContent(triggerPopup);

  return (
    <div className="w-full h-full bg-gradient-to-b from-[#E4EBF6] to-[#CCD8EB] relative overflow-hidden">
      {!hideFreeBadge && (
        <div className="bg-[#2D9425] absolute -rotate-45 px-12 font-bold text-white -left-10 top-4">FREE</div>
      )}

      {decorativeContent}
      <div
        className={clsxm(
          'flex flex-col gap-2',
          'bg-[#e2e9f4] outline outline-1 outline-white/90 scale-75 absolute bottom-24 right-5 rounded-lg',
          'px-4 py-2',
          'shadow-lg'
        )}
      >
        <div className="flex gap-2">
          <StarSVG />
          <StarSVG />
          <StarSVG />
          <StarSVG />
          <StarSVG />
        </div>
        <div>4.6/5 of 146 reviews</div>
      </div>
    </div>
  );
};

const StarSVG: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.04894 0.92705C7.3483 0.00573921 8.6517 0.00573969 8.95106 0.92705L10.0206 4.21885C10.1545 4.63087 10.5385 4.90983 10.9717 4.90983H14.4329C15.4016 4.90983 15.8044 6.14945 15.0207 6.71885L12.2205 8.75329C11.87 9.00793 11.7234 9.4593 11.8572 9.87132L12.9268 13.1631C13.2261 14.0844 12.1717 14.8506 11.388 14.2812L8.58778 12.2467C8.2373 11.9921 7.7627 11.9921 7.41221 12.2467L4.61204 14.2812C3.82833 14.8506 2.77385 14.0844 3.0732 13.1631L4.14277 9.87132C4.27665 9.4593 4.12999 9.00793 3.7795 8.75329L0.979333 6.71885C0.195619 6.14945 0.598395 4.90983 1.56712 4.90983H5.02832C5.46154 4.90983 5.8455 4.63087 5.97937 4.21885L7.04894 0.92705Z"
        fill="#2C9424"
      />
    </svg>
  );
};
